export default {
    title: 'Status ändern',

    changeStatus: 'Status ändern',
    status: 'Status',

    changeStatusHelpText: 'Sollten bei einer Statusänderung bearbeitbare Statusbenachrichtigungen ausgelöst werden, werden diese sofort verschickt, ohne dass eine Bemerkung gesetzt werden kann.',

    maxProcessesForChangingStatus: 'Es können maximal {max} Vorgänge gleichzeitig bearbeitet werden.',
    changeStatusNotAvailableForProcesses: 'Der ausgewählte Status ist für die folgenden Vorgänge nicht verfügbar: {processes}.',

    statusChangedSuccessfully: 'Der Status wurde erfolgreich geändert.',
    errorOnChangeStatus: 'Fehler beim Ändern des Status.',
}